import React from 'react';
import {Button, Card, CardContent, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import { Visibility } from '@mui/icons-material';

const PersonaQueEmiteFactura = ({datosGeneralesDeSolicitud, obtenerDocumentoAdjunto}) => {
  const classes = styles();
  const {nitSolicitante, nombreSolicitante, rgaeRegistro, rgaeResolucion, rgaeFolio} = datosGeneralesDeSolicitud;

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <TituloConIcono title={"Constancia de Inscripción del Registro Tributario Unificado - RTU"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'NIT:'} label={nitSolicitante || ""}/>
              <ElementoDelCard title={'Nombre entidad / solicitante:'} label={nombreSolicitante || ""}/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Constancia RGAE"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Número de expediente:'} label={rgaeRegistro || ""}/>
              <ElementoDelCard title={'Número de resolución:'} label={rgaeResolucion || ""}/>
              <ElementoDelCard title={'Folio:'} label={rgaeFolio || ""}/>
            </Grid>
            <Grid container justify="center" alignItems="center">
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, "constanciaRTU")} size="large">
                <Visibility />
                Ver constancia de RTU
              </Button>
            </Grid>
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 1, nombre: "empresa"}, "pdfResolucion")} size="large">
                <Visibility />
                Ver resolución y constancia de RGAE
              </Button>
            </Grid>
          </Grid>
          </Grid>
        </CardContent>
    </Card>
  );
}

export default PersonaQueEmiteFactura;